export const columnsToExport = [
  'entregados',
  'entregadosSpecified',
  'preasignados',
  'preasignadosSpecified',
  'reposicionVacios',
  'reposicionVaciosSpecified',
  'tipoTamano',
  'transito',
  'transitoSpecified',
  'viaje',
];
